import { z } from 'zod';

// ── Request (POST /valet/tickets/:id/comp) ────────────────────────────────────

export const ApplyCompRequestSchema = z.object({
  reason: z.string().trim().min(1).max(500),
});

export type ApplyCompRequest = z.infer<typeof ApplyCompRequestSchema>;

// ── Response ──────────────────────────────────────────────────────────────────

export const ApplyCompResponseSchema = z.object({
  ticketId: z.string().uuid(),
  paymentMethod: z.literal('comp'),
  paymentStatus: z.literal('paid'),
  reason: z.string(),
  appliedAt: z.string().datetime(),
});

export type ApplyCompResponse = z.infer<typeof ApplyCompResponseSchema>;
